<div class="album-linha" [class.album-linha-cliente]="ehCliente">
  <div class="album" [class.album-cliente]="ehCliente" [class.album-enviando]="enviando"
      [attr.data-qtd]="visiveis.length">
    @for (mensagem of visiveis; track mensagem.id; let ultimo = $last) {
      <button type="button" class="album-item" [attr.data-msg-id]="mensagem.id" [attr.data-meta-id]="mensagem.metaId"
              [attr.aria-label]="'Abrir imagem ' + ($index + 1) + ' de ' + mensagens.length" (click)="abrir(mensagem, $event)">
        @if (comErro().has(mensagem.urlImage)) {
          <span class="album-erro"><mat-icon>image_not_supported</mat-icon></span>
        } @else {
          <img [src]="mensagem.urlImage" alt="" loading="lazy" (error)="aoFalhar(mensagem.urlImage)" />
        }
        @if (ultimo && excedentes > 0) {
          <span class="album-mais">+{{ excedentes }}</span>
        }
      </button>
    }
    @for (mensagem of mensagens.slice(visiveis.length); track mensagem.id) {
      <span class="album-oculta" [attr.data-msg-id]="mensagem.id" [attr.data-meta-id]="mensagem.metaId"></span>
    }

    <span class="album-rodape">
      <span class="album-hora">{{ ultima?.date | date: 'HH:mm' }}</span>
      @if (enviando) {
        <mat-icon class="album-status">schedule</mat-icon>
      } @else if (!ehCliente) {
        @switch (statusUltima) {
          @case ('SENT') {
            <mat-icon class="album-status">check</mat-icon>
          }
          @case ('DELIVERED') {
            <mat-icon class="album-status">done_all</mat-icon>
          }
          @case ('READ') {
            <mat-icon class="album-status album-status-lida">done_all</mat-icon>
          }
          @case ('FAILED') {
            <mat-icon class="album-status album-status-erro">error</mat-icon>
          }
        }
      }
    </span>
  </div>
</div>
